type Props = {
  className?: string;
};

export const Email = ({ className }: Props) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.408726 4.54754C0 5.3497 0 6.3998 0 8.5V11.5C0 13.6002 0 14.6503 0.408726 15.4525C0.768251 16.1581 1.34193 16.7317 2.04754 17.0913C2.8497 17.5 3.8998 17.5 6 17.5H14C16.1002 17.5 17.1503 17.5 17.9525 17.0913C18.6581 16.7317 19.2317 16.1581 19.5913 15.4525C20 14.6503 20 13.6002 20 11.5V8.5C20 6.3998 20 5.3497 19.5913 4.54754C19.2317 3.84193 18.6581 3.26825 17.9525 2.90873C17.1503 2.5 16.1002 2.5 14 2.5H6C3.8998 2.5 2.8497 2.5 2.04754 2.90873C1.34193 3.26825 0.768251 3.84193 0.408726 4.54754ZM4.28165 5.97781C3.85518 5.68419 3.27144 5.79188 2.97782 6.21835C2.6842 6.64481 2.79189 7.22855 3.21835 7.52217L9.26883 11.6879C9.71786 11.9971 10.3112 11.9965 10.7596 11.6864L16.7832 7.52109C17.2091 7.2266 17.3156 6.64264 17.0211 6.21678C16.7266 5.79091 16.1426 5.68441 15.7168 5.9789L10.0124 9.92348L4.28165 5.97781Z"
      fill="white"
    />
  </svg>
);
